import logo from './logo.svg';
import './App.css';
import {BrowserRouter, Link,Route,Routes} from 'react-router-dom';
import { RoutesConfig } from './RoutesConfig';
import Navbar from './components/Navbar';
import { Provider } from './Context';
import { AuthActionsContext } from './components/useAuthActions';
import { useContext } from 'react';

function App() {
  const Auth = useContext(AuthActionsContext);
  return (
    <div>
      <Provider value={Auth}>
        <Navbar/>
      </Provider>
      <BrowserRouter>
        <Routes>
        {
          RoutesConfig.map((value,key) => {
            return <Route 
                key={key}
                path={value.path}
                element={value.component}
                exact={value.exact}
              ></Route>
          })
        }
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
